/* Mansion Custom Homepage — scoped JS
   Handles quick "Add to Cart" from product cards using Shopify AJAX Cart API.
   Does not replace your theme's cart drawer; dispatches events that most
   Online Store 2.0 themes (Dawn, Impulse, Motion, etc.) listen for. */
(function () {
  'use strict';

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2);
    }
  }

  function refreshCartBadges(cart) {
    document.querySelectorAll('[data-cart-count-bubble],[data-cart-count],.cart-count-bubble span').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  function openThemeCart() {
    var drawer = document.querySelector('cart-drawer, cart-notification, #CartDrawer, .cart-drawer, .drawer--cart');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    if (drawer) { drawer.classList.add('active', 'is-open', 'open'); return; }
    // Fallback: go to /cart
    window.location.href = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart' : '/cart';
  }

  function toast(msg) {
    var t = document.createElement('div');
    t.textContent = msg;
    t.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);background:#2a2622;color:#faf8f5;padding:12px 20px;font-size:12px;letter-spacing:.18em;text-transform:uppercase;z-index:9999;opacity:0;transition:opacity .2s;';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.style.opacity = '1'; });
    setTimeout(function () { t.style.opacity = '0'; setTimeout(function () { t.remove(); }, 300); }, 1800);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mh-card__add[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;

    var variantId = btn.getAttribute('data-variant-id');
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Adding…';

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('Add failed'); return r.json(); })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        refreshCartBadges(cart);
        toast('Added to cart');
        openThemeCart();
      })
      .catch(function () { toast('Could not add to cart'); })
      .finally(function () {
        btn.disabled = false;
        btn.innerHTML = original;
      });
  });

  // Placeholder for future intersection-observer animations
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mh-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('.mansion-home [data-mh-reveal]').forEach(function (el) { io.observe(el); });
  }

  // Expose helper for debugging
  window.MansionHome = { money: money };
})();
